// extracted by css-extract-rspack-plugin
export default {"sortGroupMobileOnly":"SortMenu-module__sortGroupMobileOnly__ulRpS","sortLabel":"SortMenu-module__sortLabel__DkYbo"};